/*
 * @Author: LHH
 * @Date: 2019-12-18 17:19:13
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
     {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    }
  ]
})
